export const START_GAME 		= 'START_GAME';
export const ADD_GAME_DATA 		= 'ADD_GAME_DATA';
export const UPDATE_GAME_DATA 	= 'UPDATE_GAME_DATA';
export const REMOVE_GAME_DATA 	= 'REMOVE_GAME_DATA';
export const LOG_GAME_RESULT 	= 'LOG_GAME_RESULT';
export const EXIT_GAME 			= 'EXIT_GAME';
